import { ErrorBag } from 'vee-validate';
export default  class Counter {
  constructor(quill, options) {
    this.quill = quill;
    this.options = options;
    
    this.field = options.container.replace('#','');
    this.container = document.querySelector(options.container);
    this.controlContainer = document.querySelector(options.controlContainer + ' div.ql-container');
    this.toolbarContainer = document.querySelector(options.controlContainer + ' div.ql-toolbar.ql-snow');
    quill.on('text-change', this.update.bind(this));
    this.update();  // Account for initial contents
  }

 
  update() {
      var length = this.quill.root.innerHTML.length;
      if(this.quill.root.innerHTML ==='<p class="ql-align-justify"><br></p>')
        length = length - length;
      this.container.innerText = length + ' / ' + this.options.max;
      if (length > this.options.max) {
        this.container.style.color = "red";
        if(this.controlContainer !== null)
          this.controlContainer.classList.add("ql-error");
        if(this.toolbarContainer !== null)
          this.toolbarContainer.classList.add("ql-error");
        
      }
      else
      {
        this.container.style.color = "#979797";
        if(this.controlContainer !== null)
          this.controlContainer.classList.remove("ql-error");
        if(this.toolbarContainer !== null)
          this.toolbarContainer.classList.remove("ql-error");
      }
        
  }
}


